<template>
  <div v-if="list && list.length" class="promo-presets-block l-container">
    <ui-horizontal-scroll ref="presets" class="top-presets" :style="style">
      <div ref="presetsList" class="top-presets_list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="top-presets_btn"
        >
          <ui-ui-button mode="link" type="secondary" :path="item.slug">
            <span class="preset-name text-body-m-book">{{ item.name }}</span>
          </ui-ui-button>
        </div>
      </div>
      <ui-ui-button-ico
        v-if="showMore"
        icon="down"
        class="show-all_btn"
        :class="{ open: isOpened }"
        mode="button"
        stroke="white"
        size-ico="20"
        @click="onShowMore"
      />
    </ui-horizontal-scroll>
  </div>
</template>
<script setup lang="ts">
import { useShowMore } from '~/composition/useShowMore';

defineProps({
  list: {
    type: Array,
  },
});
const presets = ref<{ $el: HTMLElement }>();
const presetsList = ref<HTMLElement>();

const { onShowMore, isOpened, showMore, style } = useShowMore(
  presets,
  presetsList,
  0
);
</script>
<style lang="scss" scoped src="./promo-presetsScss.scss"></style>
